import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { Variant, Scheme } from '../../../Constants/System';
import Icon from '../../Content/Icon';
import { ModalWidths } from './Modal';
import ModalContent from './ModalContent';
export default function StepperModalContent(props) {
    const { items, title } = props;
    const [currentIndex, setCurrentIndex] = useState(0);
    const itemToDisplay = items[currentIndex];
    const actions = [
        {
            text: (_jsxs(_Fragment, { children: [_jsx(Icon, { name: 'arrow-left' }), "Back"] })),
            className: 'action-button',
            variant: Variant.quiet,
            callback: () => itemToDisplay.canGoBack() && setCurrentIndex((i) => i - 1),
            disabled: !itemToDisplay.canGoBack(),
        },
        currentIndex === items.length - 1
            ? {
                text: (_jsxs(_Fragment, { children: ["Finish", _jsx(Icon, { name: 'check' })] })),
                className: 'action-button',
                callback: () => itemToDisplay.canGoNext() && itemToDisplay.callback?.(),
                disabled: !itemToDisplay.canGoNext(),
                scheme: Scheme.info,
            }
            : {
                text: (_jsxs(_Fragment, { children: ["Next", _jsx(Icon, { name: 'arrow-right' })] })),
                className: 'action-button',
                callback: () => itemToDisplay.canGoNext() && setCurrentIndex((page) => page + 1),
                disabled: !itemToDisplay.canGoNext(),
                scheme: Scheme.info,
            },
    ];
    return (_jsx(StyledModalContent, { "$width": props.width ?? ModalWidths.LARGE, title: title, actions: actions, body: itemToDisplay.component() }));
}
const StyledModalContent = styled(ModalContent) `
	width: ${(props) => props.$width};

	.action-button {
		align-self: flex-start;
		display: flex;
		align-items: center;

		.icon {
			margin: 0 ${(props) => props.theme.spacing.xs};
		}
	}
`;
//# sourceMappingURL=StepperModalContent.js.map